import React from 'react'
import { FaUsers } from "react-icons/fa";
import { PiBackpackBold } from "react-icons/pi";
import { GoRocket } from "react-icons/go";
import { LuNotebook } from "react-icons/lu";

const PermissionList = () => {
  return (
  <div className="page-content">
  {/* Start Container Fluid */}
  <div className="container-fluid">
    {/* ========== Page Title Start ========== */}
    <div className="row">
      <div className="col-12">
        <div className="page-title-box">
          <h4 className="mb-0 fw-semibold">Permissions</h4>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <a href="javascript: void(0);">Users</a>
            </li>
            <li className="breadcrumb-item active">Permissions</li>
          </ol>
        </div>
      </div>
    </div>
    {/* ========== Page Title End ========== */}
    <div className="row">
      <div className="col-lg-3">
        <div className="card">
          <div className="card-body">
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <h4 className="card-title mb-2 d-flex align-items-center gap-2">
                  Employees
                </h4>
                <p className="text-muted fw-medium fs-22 mb-0">54</p>
              </div>
              <div>
                <div className="avatar-md bg-primary bg-opacity-10 rounded">
                <FaUsers 
                    className="fs-32 text-primary avatar-title"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-3">
        <div className="card">
          <div className="card-body">
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <h4 className="card-title mb-2 d-flex align-items-center gap-2">
                  Assigned Manager
                </h4>
                <p className="text-muted fw-medium fs-22 mb-0">13</p>
              </div>
              <div>
                <div className="avatar-md bg-primary bg-opacity-10 rounded">
              <PiBackpackBold 
                    className="fs-32 text-primary avatar-title"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-3">
        <div className="card">
          <div className="card-body">
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <h4 className="card-title mb-2 d-flex align-items-center gap-2">
                  Project
                </h4>
                <p className="text-muted fw-medium fs-22 mb-0">19</p>
              </div>
              <div>
                <div className="avatar-md bg-primary bg-opacity-10 rounded">
              <GoRocket 
                    className="fs-32 text-primary avatar-title"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-3">
        <div className="card">
          <div className="card-body">
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <h4 className="card-title mb-2 d-flex align-items-center gap-2">
                  License Used
                </h4>
                <p className="text-muted fw-medium fs-22 mb-0">36/50</p>
              </div>
              <div>
                <div className="avatar-md bg-primary bg-opacity-10 rounded">
                <LuNotebook 
                    className="fs-32 text-primary avatar-title"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-xl-12">
        <div className="card">
          <div className="d-flex card-header justify-content-between align-items-center">
            <div>
              <h4 className="card-title">All Permissions List</h4>
            </div>
            <div className="dropdown">
              <a
                href="#"
                className="dropdown-toggle btn btn-sm btn-outline-light rounded"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                This Month
              </a>
              <div className="dropdown-menu dropdown-menu-end">
                {/* item*/}
                <a href="#!" className="dropdown-item">
                  Download
                </a>
                {/* item*/}
                <a href="#!" className="dropdown-item">
                  Export
                </a>
                {/* item*/}
                <a href="#!" className="dropdown-item">
                  Import
                </a>
              </div>
            </div>
          </div>
          <div>
            <div className="table-responsive">
              <table className="table align-middle mb-0 table-hover table-centered">
                <thead className="bg-light-subtle">
                  <tr>
                    <th style={{ width: 20 }}>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customCheck1"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customCheck1"
                        />
                      </div>
                    </th>
                    <th>Name</th>
                    <th>Assigned To</th>
                    <th>Created Date &amp; Time</th>
                    <th>Last Update</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customCheck2"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customCheck2"
                        >
                          &nbsp;
                        </label>
                      </div>
                    </td>
                    <td>
                      <p className="fs-15 mb-0">User Management</p>
                    </td>
                    <td>
                      <span className="badge bg-primary-subtle text-primary py-1 px-2 fs-11">
                        Manager
                      </span>
                    </td>
                    <td>4 Mar 2023, 08:30 am</td>
                    <td>Today</td>
                    <td>
                      <div className="d-flex gap-2">
                        <a href="#!" className="btn btn-light btn-sm">
                          <i className="fa-solid fa-eye align-middle fs-18"></i>
                        </a>
                        <a href="#!" className="btn btn-soft-primary btn-sm">
                          <i class="fa-solid fa-pencil align-middle fs-18"></i>
                        </a>
                        <a href="#!" className="btn btn-soft-danger btn-sm">
                          <i class="fa-solid fa-trash align-middle fs-18"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customCheck2"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customCheck2"
                        >
                          &nbsp;
                        </label>
                      </div>
                    </td>
                    <td>
                      <p className="fs-15 mb-0">Financial Management</p>
                    </td>
                    <td>
                      <span className="badge bg-info-subtle text-info py-1 px-2 fs-11">
                        Administrator
                      </span>
                      <span className="badge bg-light text-dark py-1 px-2 fs-11">
                        Developer
                      </span>
                    </td>
                    <td>27 Jun 2024, 12:00 am</td>
                    <td>Yesterday</td>
                    <td>
                      <div className="d-flex gap-2">
                        <a href="#!" className="btn btn-light btn-sm">
                          <i className="fa-solid fa-eye align-middle fs-18"></i>
                        </a>
                        <a href="#!" className="btn btn-soft-primary btn-sm">
                          <i class="fa-solid fa-pencil align-middle fs-18"></i>
                        </a>
                        <a href="#!" className="btn btn-soft-danger btn-sm">
                          <i class="fa-solid fa-trash align-middle fs-18"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customCheck2"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customCheck2"
                        >
                          &nbsp;
                        </label>
                      </div>
                    </td>
                    <td>
                      <p className="fs-15 mb-0">Content Management</p>
                    </td>
                    <td>
                      <span className="badge bg-primary-subtle text-primary py-1 px-2 fs-11">
                        Manager
                      </span>
                      <span className="badge bg-info-subtle text-info py-1 px-2 fs-11">
                        Administrator
                      </span>
                    </td>
                    <td>02 Dec 2023, 02:30 am</td>
                    <td>06 Dec 2023</td>
                    <td>
                      <div className="d-flex gap-2">
                        <a href="#!" className="btn btn-light btn-sm">
                          <i className="fa-solid fa-eye align-middle fs-18"></i>
                        </a>
                        <a href="#!" className="btn btn-soft-primary btn-sm">
                          <i class="fa-solid fa-pencil align-middle fs-18"></i>
                        </a>
                        <a href="#!" className="btn btn-soft-danger btn-sm">
                          <i class="fa-solid fa-trash align-middle fs-18"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customCheck2"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customCheck2"
                        >
                          &nbsp;
                        </label>
                      </div>
                    </td>
                    <td>
                      <p className="fs-15 mb-0">Payroll</p>
                    </td>
                    <td>
                      <span className="badge bg-primary-subtle text-primary py-1 px-2 fs-11">
                        Manager
                      </span>
                      <span className="badge bg-info-subtle text-info py-1 px-2 fs-11">
                        Administrator
                      </span>
                      <span className="badge bg-success-subtle text-success py-1 px-2 fs-11">
                        Analyst
                      </span>
                      <span className="badge bg-warning-subtle text-warning py-1 px-2 fs-11">
                        Trial
                      </span>
                    </td>
                    <td>27 Jun 2024, 12:00 am</td>
                    <td>14 May 2024</td>
                    <td>
                      <div className="d-flex gap-2">
                        <a href="#!" className="btn btn-light btn-sm">
                          <i className="fa-solid fa-eye align-middle fs-18"></i>
                        </a>
                        <a href="#!" className="btn btn-soft-primary btn-sm">
                          <i class="fa-solid fa-pencil align-middle fs-18"></i>
                        </a>
                        <a href="#!" className="btn btn-soft-danger btn-sm">
                          <i class="fa-solid fa-trash align-middle fs-18"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customCheck2"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customCheck2"
                        >
                          &nbsp;
                        </label>
                      </div>
                    </td>
                    <td>
                      <p className="fs-15 mb-0">Reporting</p>
                    </td>
                    <td>
                      <span className="badge bg-primary-subtle text-primary py-1 px-2 fs-11">
                        Manager
                      </span>
                      <span className="badge bg-warning-subtle text-warning py-1 px-2 fs-11">
                        Trial
                      </span>
                      <span className="badge bg-light text-dark py-1 px-2 fs-11">
                        Developer
                      </span>
                    </td>
                    <td>13 Aug 2024, 07:05 am</td>
                    <td>Today</td>
                    <td>
                      <div className="d-flex gap-2">
                        <a href="#!" className="btn btn-light btn-sm">
                          <i className="fa-solid fa-eye align-middle fs-18"></i>
                        </a>
                        <a href="#!" className="btn btn-soft-primary btn-sm">
                          <i class="fa-solid fa-pencil align-middle fs-18"></i>
                        </a>
                        <a href="#!" className="btn btn-soft-danger btn-sm">
                          <i class="fa-solid fa-trash align-middle fs-18"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customCheck2"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customCheck2"
                        >
                          &nbsp;
                        </label>
                      </div>
                    </td>
                    <td>
                      <p className="fs-15 mb-0">API Controls</p>
                    </td>
                    <td>
                      <span className="badge bg-primary-subtle text-primary py-1 px-2 fs-11">
                        Manager
                      </span>
                      <span className="badge bg-success-subtle text-success py-1 px-2 fs-11">
                        Analyst
                      </span>
                    </td>
                    <td>28 Sep 2023, 01:20 pm</td>
                    <td>10 Oct 2023</td>
                    <td>
                      <div className="d-flex gap-2">
                        <a href="#!" className="btn btn-light btn-sm">
                          <i className="fa-solid fa-eye align-middle fs-18"></i>
                        </a>
                        <a href="#!" className="btn btn-soft-primary btn-sm">
                          <i class="fa-solid fa-pencil align-middle fs-18"></i>
                        </a>
                        <a href="#!" className="btn btn-soft-danger btn-sm">
                          <i class="fa-solid fa-trash align-middle fs-18"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customCheck2"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customCheck2"
                        >
                          &nbsp;
                        </label>
                      </div>
                    </td>
                    <td>
                      <p className="fs-15 mb-0">Disputes Management</p>
                    </td>
                    <td>
                      <span className="badge bg-primary-subtle text-primary py-1 px-2 fs-11">
                        Manager
                      </span>
                      <span className="badge bg-light text-dark py-1 px-2 fs-11">
                        Developer
                      </span>
                    </td>
                    <td>10 Feb 2025, 06:00 pm</td>
                    <td>Yesterday</td>
                    <td>
                      <div className="d-flex gap-2">
                        <a href="#!" className="btn btn-light btn-sm">
                          <i className="fa-solid fa-eye align-middle fs-18"></i>
                        </a>
                        <a href="#!" className="btn btn-soft-primary btn-sm">
                          <i class="fa-solid fa-pencil align-middle fs-18"></i>
                        </a>
                        <a href="#!" className="btn btn-soft-danger btn-sm">
                          <i class="fa-solid fa-trash align-middle fs-18"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customCheck2"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customCheck2"
                        >
                          &nbsp;
                        </label>
                      </div>
                    </td>
                    <td>
                      <p className="fs-15 mb-0">Database Management</p>
                    </td>
                    <td>
                      <span className="badge bg-primary-subtle text-primary py-1 px-2 fs-11">
                        Manager
                      </span>
                      <span className="badge bg-info-subtle text-info py-1 px-2 fs-11">
                        Administrator
                      </span>
                      <span className="badge bg-light text-dark py-1 px-2 fs-11">
                        Developer
                      </span>
                    </td>
                    <td>19 Jul 2024, 09:45 pm</td>
                    <td>Yesterday</td>
                    <td>
                      <div className="d-flex gap-2">
                        <a href="#!" className="btn btn-light btn-sm">
                          <i className="fa-solid fa-eye align-middle fs-18"></i>
                        </a>
                        <a href="#!" className="btn btn-soft-primary btn-sm">
                          <i class="fa-solid fa-pencil align-middle fs-18"></i>
                        </a>
                        <a href="#!" className="btn btn-soft-danger btn-sm">
                          <i class="fa-solid fa-trash align-middle fs-18"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customCheck2"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customCheck2"
                        >
                          &nbsp;
                        </label>
                      </div>
                    </td>
                    <td>
                      <p className="fs-15 mb-0">Repository Management</p>
                    </td>
                    <td>
                      <span className="badge bg-info-subtle text-info py-1 px-2 fs-11">
                        Administrator
                      </span>
                      <span className="badge bg-light text-dark py-1 px-2 fs-11">
                        Developer
                      </span>
                    </td>
                    <td>05 Jan 2024, 11:00 am</td>
                    <td>03 Dec 2023</td>
                    <td>
                      <div className="d-flex gap-2">
                        <a href="#!" className="btn btn-light btn-sm">
                          <i className="fa-solid fa-eye align-middle fs-18"></i>
                        </a>
                        <a href="#!" className="btn btn-soft-primary btn-sm">
                          <i class="fa-solid fa-pencil align-middle fs-18"></i>
                        </a>
                        <a href="#!" className="btn btn-soft-danger btn-sm">
                          <i class="fa-solid fa-trash align-middle fs-18"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {/* end table-responsive */}
          </div>
          <div className="card-footer border-top">
            <nav aria-label="Page navigation example">
              <ul className="pagination justify-content-end mb-0">
                <li className="page-item">
                  <a className="page-link" href="javascript:void(0);">
                    Previous
                  </a>
                </li>
                <li className="page-item active">
                  <a className="page-link" href="javascript:void(0);">
                    1
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="javascript:void(0);">
                    2
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="javascript:void(0);">
                    3
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="javascript:void(0);">
                    Next
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* End Container Fluid */}
  {/* ========== Footer Start ========== */}
  <footer className="footer">
    <div className="container-fluid">
      <div className="row">
        <div className="col-12 text-center">
          © Venton. Crafted by{" "}
          <iconify-icon
            icon="iconamoon:heart-duotone"
            className="fs-18 align-middle text-danger"
          />{" "}
          <a href="" className="fw-bold footer-text" target="_blank">
            Techzaa
          </a>
        </div>
      </div>
    </div>
  </footer>
  {/* ========== Footer End ========== */}
</div>

  )
}

export default PermissionList
